export default (state = {
    fetched: false,
    attributes: [],
    requireVariantUpdate: false,
    has_variants: false,
    variantsIndexes: [],
    color: [],
    variants: [],
    images: [],
}, action) => {
    switch (action.type) {
        case 'FETCHING_EDIT_PRODUCT_FORM' :
            return {
                ...state,
                fetched: false
            };
        case 'FETCHING_EDIT_PRODUCT_FORM_FAILED' :
            return {
                ...state,
                fetched: 0
            };
        case 'FETCH_EDIT_PRODUCT_FORM' :
            return {
                ...state,
                ...action.results,
                fetched: true
            };
        case 'EDIT_PRODUCT_FORM_REQUIRE_VARIANT_UPDATE' :
            return {
                ...state,
                requireVariantUpdate: action.status
            };
        case 'EDIT_PRODUCT_UPDATE_VARIANT_INDEXES' :
            return {
                ...state,
                variantsIndexes: action.variants
            };
        case 'EDIT_PRODUCT_FORM_UPDATE_HAS_VARIANTS' :
            return {
                ...state,
                has_variants: action.status
            };
        case 'EDIT_PRODUCT_FORM_UPDATE_IMAGES' :
            return {
                ...state,
                images: action.images
            };
        default:
            return state;
    }
};